import { PlotCreatePage } from '@/components/plots/plot-create-page'

export function AdminPlotCreate() {
  return <PlotCreatePage plotsBasePath="/admin/plots" />
}
